import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { CoreService, HttpService } from '../../../services';
import { BoAdminBaseComponent } from '../boadmin-base.component';
import { BObjectModel, TableDefaultValue, PropertyDetailsModel, BoModel, GroupValueData, PropertyData, ComboBox } from '../../../models';
import * as _jquery from 'jquery';
import { ToastService } from '../../../toast';
import { AdminPropDataService } from './admin.propdata.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
const $: JQueryStatic = _jquery;

@Component({
  selector: 'q-adminpropdata',
  templateUrl: './admin.propdata.component.html',
  styleUrls: ['./admin.propdata.component.css']
})

export class AdminPropDataComponent extends BoAdminBaseComponent implements OnInit {
  private initOption: PropBoOption | null;
  private modelPROP: PropertyDetailsModel;
  private propertyGroup: GroupValueData | null = null; /* Group associated to the property containing the list of Automatic-values */
  private selectedGroupCode: string = '';

  private readonly VALCODE_EMPTY: string = `Préciser un code pour la nouvelle valeur`;
  private readonly TEXTCODE_EMPTY: string = `Préciser un texte pour la nouvelle valeur`;
  private readonly VALCODE_WRONG: string = `la valeur saisie est erronée`;
  activeTab: string = 'PROP';
  isCombo: boolean = false; /* true if the property is type=COMBO => with automatic values management (AUTO Tab) */

  //#region Tab PROP
  modelBO: BObjectModel; /* BO model for opening the BO of the property loaded in the PROP Tab  */
  //#endregion

  //#region Tab AUTO
  comboTitle: string = ''; /* propertyGroup.Info_BOV */
  newValueA: TableDefaultValue = this.newTableDefaultValue(); /* new item for automatic-values-list linked to prop (loadedItem) */
  newValueACode: string = ''; /* new item code */
  newValueAText: string = ''; /* new item value */
  newValueB: TableDefaultValue = this.newTableDefaultValue(); /* new item for automatic-values-list not linked to prop (unloadedItem) */
  newValueBCode: string = ''; /* new item code */
  newValueBText: string = ''; /* new item value */
  loadedItem: CmbValues = new CmbValues(ListMode.NONE, []); /* LIST OF AUTOMATIC VALUES ITEMS LINKED TO THE PROPERTY */
  unloadedItem: CmbValues = new CmbValues(ListMode.NONE, []); /* LIST OF AUTOMATIC VALUES ITEMS NOT LINKED TO THE PROPERTY */
  propertiesWithSameGroup: Array<ComboBox> = new Array<ComboBox>(); /* PERMET DE LIER DE VALEURS A PLUSIERS PROPRIETES SIMULTANEMENT */
  AllPropertiesWithSameGroupChecked: boolean = false;

  modalProperties: NgbModalRef;
  //#endregion

  //#region Tab Group
  addNewGroup: boolean = false; /* add new group as auto value to property */
  newGroupCode: string = ''; /* new item code */
  newGroupText: string = ''; /* new item value */
  showNewGroupItems: boolean = false;
  nameNewGroup: string = '';
  newValueG: TableDefaultValue = this.newTableDefaultValue('*'); /* new item for automatic-values-list not linked to prop (unloadedItem) */
  newValueGCode: string = ''; /* new item code */
  newValueGText: string = ''; /* new item value */
  selectedGroupItems: CmbValues = new CmbValues(ListMode.NONE, []); /* LIST OF AUTOMATIC VALUES ITEMS LINKED TO SPECIFIC GROUP */
  tabDisable: boolean = false;
  //#endregion

  @Input('options') set options(value: PropBoOption) {
    this.initOption = value;
    this.initData();
  }


  @ViewChild('CheckPropertiesModal', { static: false }) CheckPropertiesModal: ElementRef;

  constructor(
    private data: HttpService,
    private indParam: CoreService,
    private propService: AdminPropDataService,
    private toast: ToastService,
    protected modalService: NgbModal,
  ) { super(); }


  ngOnInit(): void {
  }


  // shared amongs tabs
  updateValueText(value: TableDefaultValue): void {
    this.modelPROP.ComboDefault.NewGroupValue = value;
    this.modelPROP.Mode = 'NEWVALUE';
    this.indParam.showSplash(true);
    this.result = this.propService.SaveNewItem(this.modelPROP).subscribe((rdt: PropertyDetailsModel): void => {
      if (!rdt.HasError) {
        this.SetResult(rdt);
      }
      this.indParam.showSplash(false);
    });
  }
  // shared amongs tabs
  checkAllMovable(value: boolean, list: TableDefaultValue[]): void {
    list.forEach((r: TableDefaultValue): void => { r.IsSelected = value; });
  }
  // shared amongs tabs
  cleanNewValue(modo: string): void {
    switch (modo) {
      case 'A':
        this.newValueACode = '';
        this.newValueAText = '';
        this.newValueA = this.newTableDefaultValue();
        break;
      case 'B':
        this.newValueBCode = '';
        this.newValueBText = '';
        this.newValueB = this.newTableDefaultValue();
        break;
      case 'G':
        this.newValueGCode = '';
        this.newValueGText = '';
        this.newValueG = this.newTableDefaultValue('*');
        break;
    }
  }
  // shared amongs tabs
  cleanNewGroup(): void {
    this.addNewGroup = false;
    this.newGroupCode = '';
    this.newGroupText = '';
    this.showNewGroupItems = false;
    this.nameNewGroup = '';
    this.selectedGroupItems = new CmbValues(ListMode.NONE, []); /* LIST OF AUTOMATIC VALUES ITEMS LINKED TO SPECIFIC GROUP */
  }
  // shared amongs tabs
  changeTab(tabName: string): void {
    //#region before changing tab
    this.cleanNewValue('A');
    this.cleanNewValue('B');
    this.cleanNewValue('G');

    this.SizingTab(tabName);
    //#endregion

    if (tabName === 'GRP' || tabName === 'AUTO')
      this.initData();

    this.activeTab = tabName;
  }
  private SizingTab(tabname: string): void {
    if (tabname !== 'PROP') {
      const divModal: JQuery<HTMLElement> = $('#dragdiv_boPropAdmin');  // get modal div in admin.bodata.component
      const modalHeight: number = divModal.length > 0 ? parseInt(divModal.css('height')) : 0;
      const dragdivHeaderHeight: number = 45;
      const padding: number = 25;
      const tabbtnHeader: number = 56;
      const maindiv: JQuery<HTMLElement> = $('#divPropData'); // get main parent div of admin.propdata.component
      if (modalHeight > 0 && maindiv.length > 0) {
        const maindivHeight: number = (modalHeight - dragdivHeaderHeight) - padding;
        maindiv.css('height', `${maindivHeight}px`);
        if (tabname === 'AUTO') {
          const avdiv: JQuery<HTMLElement> = $('#divAutVal'); // get tab div containing auto values
          if (avdiv.length > 0) {
            const divautvalHeight: number = (maindivHeight - tabbtnHeader) - padding;
            avdiv.css('height', `${divautvalHeight}px`);
            const cntdiv: JQuery<HTMLElement> = $('.autovalues');
            if (cntdiv.length > 0) {
              const h1: number = divautvalHeight - 30;
              cntdiv.css('height', `${h1}px`);
              const cntdiv2: JQuery<HTMLElement> = $('.autovaluescontent');
              if (cntdiv2.length > 0) {
                const h2: number = (h1 - 78) - 40; /* 78 is the height of the .autovaluesheader fixed in css / 30 is the autovaluesheader padding 15 top + 15 bottom + 10 tolleranza */
                cntdiv2.css('height', `${h2}px`);
                cntdiv2.css('overflow-y', 'auto');
              }
            }
          }
        }
        if (tabname === 'GRP') {
          const grpdiv: JQuery<HTMLElement> = $('#divNewGrp'); // get tab div containing auto values
          if (grpdiv.length > 0) {
            const divautvalHeight: number = (maindivHeight - tabbtnHeader) - padding;
            grpdiv.css('height', `${divautvalHeight}px`);
          }
        }
      }
    }
  }


  // Tab AUTO
  registerSelectedValues(multiProperties: boolean = false): void {
    this.modelPROP.ComboDefault.ValuesToRemove = this.loadedItem.list.filter((e: TableDefaultValue): boolean => e.IsSelected).map((f: TableDefaultValue): number => f.Ident);
    this.modelPROP.ComboDefault.ValuesToAdd = this.unloadedItem.list.filter((e: TableDefaultValue): boolean => e.IsSelected).map((f: TableDefaultValue): number => f.Ident);
    this.modelPROP.Mode = 'SAVEVALUES';
    if (this.modelPROP.ComboDefault.ValuesToRemove.length > 0 || this.modelPROP.ComboDefault.ValuesToAdd.length > 0) {
      if (multiProperties) {
        if (this.modalProperties) {
          this.modalProperties.close();
        }
        this.propertiesWithSameGroup.forEach((prop: ComboBox) => {
          if (prop.Selected) {
            const model: PropertyDetailsModel = JSON.parse(JSON.stringify(this.modelPROP));
            model.IdentProp = prop.Value;
            this.registerValues(model, `${this.modelBO.IdDonneeFils}` === prop.Value);
          }
        })
      } else {
        this.registerValues(this.modelPROP, true);
      }
    }
  }
  // Tab AUTO
  createLoadedValue(): void {
    if (this.newValueACode === '') {
      this.toast.showWarningToast(this.VALCODE_EMPTY);
      return;
    }
    if (this.newValueAText === '') {
      this.toast.showWarningToast(this.TEXTCODE_EMPTY);
      return;
    }

    const isPropNumeric: boolean = this.initOption?.comboField === 'VaintBOV';
    if (isPropNumeric) {
      const parsed: number = parseInt(this.newValueACode);
      if (isNaN(parsed)) {
        this.toast.showWarningToast(this.VALCODE_WRONG);
        return;
      }
      this.newValueA.VastrBOV = '';
      this.newValueA.VaintBOV = this.newValueACode;
    }
    else {
      this.newValueA.VastrBOV = this.newValueACode;
      this.newValueA.VaintBOV = '';
    }

    this.newValueA.Info_BOV = this.newValueAText;
    this.newValueA.IsSelected = true; // for joining the new value to the prop

    this.modelPROP.ComboDefault.NewGroupValue = this.newValueA;
    this.modelPROP.ComboDefault.NewGroupValue.AddToPropertyIdent = '';
    this.modelPROP.Mode = 'NEWVALUE';

    this.indParam.showSplash(true);
    this.result = this.propService.SaveNewItem(this.modelPROP).subscribe((result: PropertyDetailsModel): void => {
      if (!result.HasError) {
        this.cleanNewValue('A');
        this.SetResult(result);
      }
      this.indParam.showSplash(false);
    });
  }
  // Tab AUTO
  createUnloadedValue(): void {
    if (this.newValueBCode === '') {
      this.toast.showWarningToast(this.VALCODE_EMPTY);
      return;
    }
    if (this.newValueBText === '') {
      this.toast.showWarningToast(this.TEXTCODE_EMPTY);
      return;
    }

    const isPropNumeric: boolean = this.initOption?.comboField === 'VaintBOV';
    if (isPropNumeric) {
      this.newValueB.VastrBOV = '';
      this.newValueB.VaintBOV = this.newValueBCode;
    }
    else {
      this.newValueB.VastrBOV = this.newValueBCode;
      this.newValueB.VaintBOV = '';
    }

    this.newValueB.Info_BOV = this.newValueBText;
    this.newValueB.IsSelected = false; // for not joining the new value to the prop

    this.modelPROP.ComboDefault.NewGroupValue = this.newValueB;
    this.modelPROP.ComboDefault.NewGroupValue.AddToPropertyIdent = '';
    this.modelPROP.Mode = 'NEWVALUE';

    this.indParam.showSplash(true);
    this.result = this.propService.SaveNewItem(this.modelPROP).subscribe((result: PropertyDetailsModel): void => {
      if (!result.HasError) {
        this.cleanNewValue('B');
        this.SetResult(result);
      }
      this.indParam.showSplash(false);
    });
  }
  // Tab AUTO
  deleteSelectedValues(): void {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer les valeurs sélectionnées?')) {
      this.modelPROP.ComboDefault.ValuesToRemove = this.loadedItem.list.filter((e: TableDefaultValue): boolean => e.IsSelected).map((f: TableDefaultValue): number => f.Ident);
      this.modelPROP.ComboDefault.ValuesToAdd = this.unloadedItem.list.filter((e: TableDefaultValue): boolean => e.IsSelected).map((f: TableDefaultValue): number => f.Ident);
      this.modelPROP.Mode = 'DELETEVALUES';
      if (this.modelPROP.ComboDefault.ValuesToRemove.length > 0 || this.modelPROP.ComboDefault.ValuesToAdd.length > 0) {
        this.registerValues(this.modelPROP, true);
      }
    }
  }


  // Tab Group
  createGroup(): void {
    if (this.newGroupCode !== '' && this.newGroupText !== '') {
      this.modelPROP.ComboDefault.NewGroupValue = this.newTableDefaultValue();
      this.modelPROP.ComboDefault.NewGroupValue.Ident = 0;
      this.modelPROP.ComboDefault.NewGroupValue.IdbopBOV = 'CODEVALU';
      this.modelPROP.ComboDefault.NewGroupValue.IsSelected = false;
      this.modelPROP.ComboDefault.NewGroupValue.OnEdit = false;
      this.modelPROP.ComboDefault.NewGroupValue.VastrBOV = this.newGroupCode;
      this.modelPROP.ComboDefault.NewGroupValue.VaintBOV = '';
      this.modelPROP.ComboDefault.NewGroupValue.Info_BOV = this.newGroupText;
      this.modelPROP.ComboDefault.NewGroupValue.AddToPropertyIdent = (this.addNewGroup && this.initOption) ? this.initOption.identProp : '';

      this.modelPROP.Mode = 'NEWVALUE';
      this.indParam.showSplash(true);
      this.result = this.data.postHttp<PropertyDetailsModel>(`${this.indParam.AppParams.apiUrl}api/adminprop/`, this.modelPROP).subscribe((result: PropertyDetailsModel): void => {
        if (!result.HasError) {
          if (result.HasAlert) {
            this.indParam.showSplash(false);
            //this.toast.showNotification(result.Alert);
            this.toast.showInfoToast(result.Alert);
          }
          else {

            this.selectedGroupItems = new CmbValues(ListMode.NEWGROUP, []);
            if (result.ComboDefault.NewGroupValue) {
              this.selectedGroupCode = this.newGroupCode;
              //this.showNewGroupItems = !this.addNewGroup;
              if (this.addNewGroup && this.initOption) {
                this.result = this.propService.GetPropertyComboData(this.initOption.identBO, this.initOption.identProp, this.initOption.comboField).subscribe((result: PropertyDetailsModel): void => {
                  if (!result.HasError) {
                    this.SetResult(result);
                    this.changeTab('AUTO');
                    this.showNewGroupItems = false;
                  }
                  this.indParam.showSplash(false);
                });
              }
              else {
                this.nameNewGroup = `${this.newGroupCode} - ${this.newGroupText}`;
                this.showNewGroupItems = true;
                this.cleanNewValue('G');
                this.indParam.showSplash(false);
              }
              this.newGroupCode = '';
              this.newGroupText = '';
            }

          }
        }
      });
    }
  }
  // Tab Group
  createGroupItem(): void {
    if (this.newValueGCode === '') {
      this.toast.showWarningToast(this.VALCODE_EMPTY);
      return;
    }
    if (this.newValueGText === '') {
      this.toast.showWarningToast(this.TEXTCODE_EMPTY);
      return;
    }

    this.newValueG.IdbopBOV = this.selectedGroupCode;
    this.newValueG.VastrBOV = this.newValueGCode;
    this.newValueG.VaintBOV = '';
    this.newValueG.Info_BOV = this.newValueGText;

    this.modelPROP.ComboDefault.NewGroupValue = this.newValueG;
    this.modelPROP.Mode = 'NEWVALUE';

    this.indParam.showSplash(true);
    this.result = this.propService.SaveNewItem(this.modelPROP).subscribe((result: PropertyDetailsModel): void => {
      if (!result.HasError) {
        this.selectedGroupItems.list.push(this.newValueG);
        this.cleanNewValue('G');
      }
      this.indParam.showSplash(false);
    });
  }


  // Tab PROP
  getEvent(bo: BObjectModel): void {
    this.tabDisable = true;
    let controleType: PropertyData | undefined = undefined;
    let donneeeType: PropertyData | undefined = undefined;
    bo.Body.SelectedGroupsList.forEach((grp) => {
      if (this.tabDisable) {
        let r = grp.DataList.find((data: PropertyData) => { return data.MainElementList[0].ID.toLowerCase() == "grpvabop" });
        if (r != undefined) {
          let select = r.MainElementList[0].SelectOptionsList.find((e) => { return e.Selected == true; });
          if (select) {
            this.tabDisable = select.Value ? false : true;
          } else {
            this.tabDisable = true;
          }
        } else {
          this.tabDisable = true;
        }
      }
      if (this.initOption) {
        let findControleType = grp.DataList.find((data: PropertyData) => { return data.MainElementList[0].ID.toLowerCase() == "methobop" });
        if (findControleType) {
          controleType = findControleType;
        }

        let findDonneeeType = grp.DataList.find((data: PropertyData) => { return data.MainElementList[0].ID.toLowerCase() == "tycolbop" });
        if (findDonneeeType) {
          donneeeType = findDonneeeType;
        }

        if (controleType && donneeeType) {

          let controleSelected = controleType.MainElementList[0].SelectOptionsList.find((e) => { return e.Selected == true; });
          let donneeSelected = donneeeType.MainElementList[0].SelectOptionsList.find((e) => { return e.Selected == true; });
          if (controleSelected && donneeSelected) {
            this.initOption.comboField = controleSelected.Value.toUpperCase() === 'COMBO' ? donneeSelected?.Value.toUpperCase() === 'INT' ? 'VaintBOV' : 'VastrBOV' : '';
            this.InitVariableForPropertyCombo()
          }
        }
      }

    });
  }

  OpenCheckPropertiesModal(): void {
    this.modalProperties = this.modalService.open(this.CheckPropertiesModal, {
      backdropClass: 'admin-bo-modal', windowClass: 'admin-bo-modal', centered: true
    });
  }

  OnCheckAllPropertiesWithSameGroup(): void {
    if (this.AllPropertiesWithSameGroupChecked) {
      this.propertiesWithSameGroup.forEach(
        (prop: ComboBox) => {
          prop.Selected = false;
        })
    } else {
      this.propertiesWithSameGroup.forEach(
        (prop: ComboBox) => {
          prop.Selected = true;
        })
    }
    this.AllPropertiesWithSameGroupChecked = !this.AllPropertiesWithSameGroupChecked;
  }
  AreAllPropertiesWithSameGroupChecked(prop: ComboBox): void {
    this.AllPropertiesWithSameGroupChecked = true;
    for (let i: number = 0; i < this.propertiesWithSameGroup.length; i++) {
      if (prop.Value == this.propertiesWithSameGroup[i].Value)
        this.propertiesWithSameGroup[i].Selected = !this.propertiesWithSameGroup[i].Selected;

      if (!this.propertiesWithSameGroup[i].Selected) {
        this.AllPropertiesWithSameGroupChecked = false;
        return;
      }
    }
  }

  private initData(): void {
    this.activeTab = 'PROP';
    this.loadedItem = new CmbValues(ListMode.NONE, []);
    this.unloadedItem = new CmbValues(ListMode.NONE, []);
    this.cleanNewValue('A');
    this.cleanNewValue('B');
    this.cleanNewValue('G');
    this.cleanNewGroup();

    if (this.initOption) {
      //#region init BO model for q-bodisplay component (for fidplayng the property BO)
      this.modelBO = new BObjectModel;
      this.modelBO.IdentBO = 'BO_PROP';
      this.modelBO.IdRelation = 'REL_BO_BO_BO_PROP';
      this.modelBO.IdDonneePere = this.initOption.identBO;
      this.modelBO.IdDonneeFils = this.initOption.identProp;
      this.modelBO.ShowRemoveButton = false;
      this.modelBO.ShowCreateButton = false;
      this.modelBO.ShowSaveButton = true;
      this.modelBO.Mode = 'CREATE';
    }
      //#endregion

      //#region init variables for property of type COMBO (with a list of automatic values)
      this.InitVariableForPropertyCombo();
      //#endregion
  }
  private InitVariableForPropertyCombo(): void {
    this.isCombo = false;
    if (this.initOption && this.initOption.comboField) {
      this.isCombo = true;
      this.indParam.showSplash(true);
      this.result = this.propService.GetPropertyComboData(this.initOption.identBO, this.initOption.identProp, this.initOption.comboField).subscribe((result: PropertyDetailsModel): void => {
        if (!result.HasError) {
          this.SetResult(result);
          if (this.propertyGroup != null && this.propertyGroup.VastrBOV) {
            this.propService.GetPropertiesByGroup(this.propertyGroup.VastrBOV).subscribe((result: PropertyDetailsModel) => {
              this.propertiesWithSameGroup = result.Properties;
              if (this.initOption != null) {
                for (let i: number = 0; i < this.propertiesWithSameGroup.length; i++) {
                  if (this.propertiesWithSameGroup[i].Value == this.initOption.identProp) {
                    this.propertiesWithSameGroup[i].Selected = true;
                    break;
                  }
                }
              }
            });
          }
        }
        this.indParam.showSplash(false);
      });
    }
  }

  private SetResult(model: PropertyDetailsModel): void {
    this.modelPROP = model;
    if (this.modelPROP.ComboDefault) {

      // LIST OF AUTOMATIC VALUES ITEMS LINKED TO THE PROPERTY
      this.loadedItem = new CmbValues(ListMode.LOADED, this.modelPROP.ComboDefault.LoadedValues);
      // LIST OF AUTOMATIC VALUES ITEMS NOT LINKED TO THE PROPERTY
      this.unloadedItem = new CmbValues(ListMode.UNLOADED, this.modelPROP.ComboDefault.UnloadedValues);
      // AUTOMATIC VALUES ITEMS GROUP
      this.propertyGroup = this.modelPROP.ComboDefault.GroupData;
      if (this.propertyGroup != null) {
        this.comboTitle = this.propertyGroup.Info_BOV;
      }
    }
  }

  private registerValues(datamodel: PropertyDetailsModel, setResult: boolean): void {
    this.indParam.showSplash(true);
    this.result = this.data.postHttp<PropertyDetailsModel>(`${this.indParam.AppParams.apiUrl}api/adminprop/`, datamodel).subscribe((result: PropertyDetailsModel): void => {
      if (!result.HasError) {
        if (setResult) {
          this.SetResult(result);
        }
      }
      this.indParam.showSplash(false);
    });
  }

  private newTableDefaultValue(groupName: string = ''): TableDefaultValue {
    const t: TableDefaultValue = new TableDefaultValue();
    t.Ident = 0;
    t.IdbopBOV = groupName !== ''
      ? groupName
      : this.propertyGroup ? this.propertyGroup.VastrBOV : '';
    t.Info_BOV = '';
    t.VastrBOV = '';
    t.VaintBOV = '';
    t.IsSelected = false;
    t.OnEdit = false;
    return t;
  }
}

export class AutoValueItem {
  Value: string;
  Text: string;
  Selected: boolean;
  constructor(value: string, text: string, selected: boolean) {
    this.Value = value;
    this.Text = text;
    this.Selected = selected;
  }
}

export class PropBoOption {
  identBO: string;
  dataBO: BoModel;
  identProp: string;
  codeProp: string;
  nameProp: string;
  comboField: string;
  constructor(idBo: string, dataBO: BoModel, idProp: string, codeProp: string, nameProp: string, combo: string) {
    this.identBO = idBo;
    this.dataBO = dataBO;
    this.identProp = idProp;
    this.codeProp = codeProp;
    this.nameProp = nameProp;
    this.comboField = combo;
  }
}

export class CmbValues {
  mode: number = ListMode.NONE;
  list: TableDefaultValue[] = [];
  constructor(modo: number, data: TableDefaultValue[]) {
    this.mode = modo;
    this.list = data;
  }
}

export class ListMode {
  static readonly NONE: number = 0;
  static readonly LOADED: number = 1;
  static readonly UNLOADED: number = 2;
  static readonly NEWGROUP: number = 3;
}
